import * as Yup from 'yup';

// const validEmailRegex = RegExp(
//   /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
// );
export const domainRegEx = RegExp(/^[A-Za-z0-9]+$/);
export const passwordRegEx = RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/);

export const validationSchema = Yup.object({
  tempPassword: Yup.string().required('Temporary password is required.'),
  password: Yup.string()
    .required('Password is Required')
    .matches(passwordRegEx, 'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character !@#$%^&*'),
  passwordConfirmation: Yup.string()
    .required('Password confirmation is required')
    .oneOf([Yup.ref('password')], 'Password must match'),
  termsAndConditions: Yup.boolean().oneOf([true], 'You need to agree terms and conditions.'),
});
